import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const usePingN8n = () => {
  return useMutation({
    mutationFn: async (notificationId?: string) => {
      const { data, error } = await supabase.functions.invoke('ping-n8n', {
        body: { notificationId }
      });

      if (error) throw error;
      
      return data;
    },
    onSuccess: (data) => {
      if (data.success) {
        toast.success(`n8n antwoordde in ${data.response_time_ms}ms`);
      } else {
        toast.error(`n8n fout: ${data.status}`);
      }
    },
    onError: (error) => {
      console.error("Error pinging n8n:", error);
      toast.error("Fout bij testen n8n verbinding");
    },
  });
};
